import { LanderCookie } from "../commons/Constants";
import { getCookie } from "../commons/HelperFunctions";
import Logger from "../commons/Logger";

const ROLLER_ADS_ENDPOINT =
  "https://309.eu.roller.ad/get-direct-click/godaddy/any";
const ROLLER_ADS_PID = "309";
const ROLLER_ADS_PK = "afa69c866-75ac4fb7f8ecd";

export interface RollerAd {
  url: string;
  bid: number;
  campaign_id?: number;
}

export interface RollerAdsResponse {
  ads: RollerAd[];
}

export interface RollerAdsFetchResult {
  status: number;
  ads: RollerAd[];
  error?: string;
}

interface RollerAdsFetchParams {
  rootDomain: string;
  keywords?: string[];
}

export async function fetchRollerAds(
  params: RollerAdsFetchParams
): Promise<RollerAdsFetchResult> {
  const ip = getCookie(LanderCookie.CLIENT_IP);
  if (!ip) {
    return { status: 0, ads: [], error: "No client IP available" };
  }

  const searchParams = new URLSearchParams({
    pid: ROLLER_ADS_PID,
    pk: ROLLER_ADS_PK,
    ua: navigator.userAgent,
    ip,
    lang: navigator.language || "en",
    subid1: params.rootDomain,
  });

  if (params.keywords?.length) {
    searchParams.set("keywords", params.keywords.join(","));
  }

  if (document.referrer) {
    searchParams.set("ref", document.referrer);
  }

  const url = `${ROLLER_ADS_ENDPOINT}?${searchParams.toString()}`;
  Logger.debug("RollerAds fetch", {
    endpoint: ROLLER_ADS_ENDPOINT,
    rootDomain: params.rootDomain,
    hasKeywords: Boolean(params.keywords?.length),
  });

  try {
    const response = await fetch(url, {
      credentials: "omit",
    });

    if (response.status === 204) {
      return { status: 204, ads: [] };
    }

    if (!response.ok) {
      return {
        status: response.status,
        ads: [],
        error: `HTTP ${response.status}`,
      };
    }

    const data: RollerAdsResponse = await response.json();
    return { status: 200, ads: data.ads || [] };
  } catch (error) {
    Logger.error("RollerAds fetch error:", error);
    return { status: 0, ads: [], error: String(error) };
  }
}
